// product details page review section loader set js
window.onload = function () {
  // Function to check and show/hide the review button and form
  var sectionContainer = document.getElementById(
    "shopify-section-template--16176084615348__1705907826989de2fb"
  );

  // Create loader element
  var loader = document.createElement("div");
  loader.className = "loader"; // You can style this class in your CSS for the loader appearance

  loader.className = "row justify-content-center add-margin";

  // Set loader content to an image or use background image
  loader.innerHTML =
    '<i class="fa fa-circle-o-notch fa-spin fa-fw" style="font-size: 40px;color: #513030;"></i>';

  // Append loader to the section container
  sectionContainer.appendChild(loader);
  // productsectionContainer.appendChild(loader);

  function checkAndToggleReviewsload() {
    var checktestimonialapp = document.querySelector(".stamped-container");

    if (checktestimonialapp) {
      // The target element is present, hide the loader
      loader.style.display = "none";
    }
  }

  // Check initially
  checkAndToggleReviewsload();

  // Use MutationObserver to watch for changes in the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Check again whenever the DOM changes
      checkAndToggleReviewsload();
    });
  });

  // Configure and start the observer
  var observerConfig = {
    childList: true, // Watch for changes in the child elements
    subtree: true, // Watch for changes in the whole subtree
  };

  observer.observe(document.body, observerConfig);
};
